import socratesPhilosopherBust from '@/assets/socrates-philosopher-bust.png';

interface SocratesLogoProps {
  size: 'small' | 'large';
  className?: string;
}

export const SocratesLogo = ({ size, className = '' }: SocratesLogoProps) => {
  const sizeClasses = size === 'small' ? 'w-12 h-12' : 'w-32 h-32';

  return (
    <div className={`${sizeClasses} rounded-full flex items-center justify-center bg-gradient-to-br from-amber-100 to-amber-200 border-4 border-white shadow-xl overflow-hidden ${className}`}>
      <img 
        src={socratesPhilosopherBust} 
        alt="Socrates Philosopher Bust with Headband" 
        className="w-full h-full object-cover"
      />
    </div>
  );
};
